var React = require('react');

function StatusInfo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 3.273c7.03 0 12.727 5.698 12.727 12.727 0 7.03-5.698 12.727-12.727 12.727C8.97 28.727 3.273 23.03 3.273 16 3.273 8.97 8.97 3.273 16 3.273zm-.394 10h-2.273v1.454h2.273v6.546h-2.273v1.454h6v-1.454h-2.272v-6.546l-.002-.07a1.455 1.455 0 00-1.382-1.383l-.07-.001zM16 8.12a1.212 1.212 0 100 2.424 1.212 1.212 0 000-2.424z"}));
}

StatusInfo.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = StatusInfo;

StatusInfo.default = StatusInfo;
